import * as XLSX from 'xlsx';


export const dataToXLS = (workSheetData,reportId) =>{
    // let filePath = reportId
    try {
         const worksheetName = 'Branch';
         console.log("workSheetData",workSheetData)
         const workSheet = XLSX.utils.json_to_sheet(workSheetData);
         const workBook = XLSX.utils.book_new();

         XLSX.utils.book_append_sheet(workBook, workSheet, worksheetName);

         XLSX.writeFile(workBook, reportId + '.xls');
        
    } catch (error) {
        console.log(error)
    }
   
}